import type { ElementName, EventPayload } from "../types";

import { EventName } from "@homeinstead/shared";
import { track } from "../core";
import { getTrackedClickEventBody } from "./tracked-click";

type LinkEventParams = Partial<{
  link_title: string;
  target_url: string | URL;
}>;

const commonLinkParams = ({ link_title, target_url }: LinkEventParams) => {
  return {
    link_title,
    target_url: target_url?.toString(),
  };
};

/**
 * Track a click event with the specified element name and additional properties.
 */
export const trackClickEvent = (
  element_name: ElementName,
  properties?: EventPayload,
) => {
  return track(EventName.TRACKED_CLICK, {
    ...getTrackedClickEventBody({
      element_name,
    }),
    ...properties,
  });
};

export const trackHeaderLinkClickEvent = (properties: LinkEventParams) => {
  return trackClickEvent("header_link", commonLinkParams(properties));
};

export const trackFooterLinkClickEvent = (properties: LinkEventParams) => {
  return trackClickEvent("footer_link", commonLinkParams(properties));
};

export const trackMobileMenuToggleTrackedClickEvent = ({
  is_open,
}: {
  is_open: boolean;
}) => {
  return trackClickEvent("mobile_menu_toggle", { is_open });
};

export const trackScrollToTopTrackedClickEvent = () => {
  return trackClickEvent("scroll_to_top_btn");
};

/**
 * Track a click on a video thumbnail or play button.
 * This tracks the initial click before video playback starts.
 */
export const trackVideoThumbnailClickEvent = (properties?: {
  video_id?: string;
  video_url?: string;
}) => {
  return trackClickEvent("video_thumbnail", properties);
};
